import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  AbstractDialog,
  AbstractDialogData,
  AbstractDialogResultData,
} from '@next/core-lib/dialog';
import { select, Store } from '@ngrx/store';
import { ReplaySubject } from 'rxjs';

import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { SiteState } from 'src/app/shared/models';

import { SoilAnalysis } from '../../models/soil-analysis.model';
import { selectSoilAnalysisById } from '../../store/soil-analysis.selectors';

interface SoilAnalysisDialogModel extends AbstractDialogData {
  soilAnalysisId: number;
}

@Component({
  selector: 'app-soil-analysis-dialog',
  standalone: false,
  templateUrl: './soil-analysis-dialog.component.html',
})
export class SoilAnalysisDialogComponent extends AbstractDialog implements OnInit, OnDestroy {
  data = inject<SoilAnalysisDialogModel>(MAT_DIALOG_DATA);
  protected mdDialogRef =
    inject<MatDialogRef<SoilAnalysisDialogComponent, AbstractDialogResultData>>(MatDialogRef);
  private readonly store = inject<Store<SiteState>>(Store);

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  soilAnalysis: SoilAnalysis;

  ngOnInit() {
    this.store
      .pipe(
        distinctUntilChanged(),
        takeUntil(this.destroyed$),
        select(selectSoilAnalysisById({ soilAnalysisId: this.data.soilAnalysisId })),
      )
      .subscribe((soilAnalysis) => (this.soilAnalysis = soilAnalysis));
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
